import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { listUsers } from '../../services';
import DataTable from '../../components/DataTable';

const PAGE_SIZE = 20;

function getErrorMessage(error) {
  return error.response?.data?.error || error.response?.data?.message || error.message || 'Request failed';
}

const columns = [
  { key: 'id', label: 'ID', sortable: true },
  { key: 'username', label: 'Username', sortable: true },
  { key: 'display_name', label: 'Tên hiển thị' },
  { key: 'email', label: 'Email', sortable: true },
  {
    key: 'balance',
    label: 'Số dư (USD)',
    sortable: true,
    render: (row) => row.balance?.toLocaleString('vi-VN', { minimumFractionDigits: 2 }),
  },
  {
    key: 'is_verified',
    label: 'Verified',
    render: (row) => (row.is_verified ? 'Có' : 'Không'),
  },
  { key: 'subscriptions_count', label: 'Số subscriptions' },
  {
    key: 'created_at',
    label: 'Ngày tạo',
    sortable: true,
    render: (row) => new Date(row.created_at).toLocaleString('vi-VN'),
  },
];

export default function UsersTab() {
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('id');
  const [sortDir, setSortDir] = useState('desc');
  const [page, setPage] = useState(1);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);

    listUsers({ search, sortBy, sortDir, page, pageSize: PAGE_SIZE })
      .then((data) => {
        if (cancelled) return;
        setItems(data.items);
        setTotal(data.total);
      })
      .catch((error) => {
        if (!cancelled) toast.error(getErrorMessage(error));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [search, sortBy, sortDir, page]);

  return (
    <div className="space-y-3">
      <div className="rounded-xl border border-cyan-100 bg-white p-3">
        <input
          value={search}
          onChange={(event) => {
            setSearch(event.target.value);
            setPage(1);
          }}
          placeholder="Tìm theo username hoặc email"
          className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none placeholder:text-slate-400 focus:border-cyan-400"
        />
      </div>

      <DataTable
        columns={columns}
        data={items}
        isLoading={isLoading}
        sortBy={sortBy}
        sortDir={sortDir}
        onSortChange={(nextSortBy, nextSortDir) => {
          setSortBy(nextSortBy);
          setSortDir(nextSortDir);
        }}
        page={page}
        pageSize={PAGE_SIZE}
        total={total}
        onPageChange={setPage}
      />
    </div>
  );
}
